export const en = {
  login: {
    TITLE: 'Log In',
    EMAIL: { TEXT: 'Email', PLACEHOLDER: 'Email Address' },
    PASSWORD: { TEXT: 'Password', PLACEHOLDER: '**********' },
    RECOVER: { TEXT: 'Forgot Password' },
  },
  'password-recovery': {
    TITLE: 'Password Recovery',
    SUCCESS: {
      SUMMARY: 'Email Sent',
      DETAIL: 'Check your email and follow the instructions',
    },
  },
  roles: {
    ADMIN: 'Administrator',
    MANUFACTURE: 'Manufacture',
  },
  strings: {
    LOGOUT_SUCCESS: 'You have successfully logged out',
    PROFILE: 'Profile',
    HOME: 'Home',
    DASHBOARD: 'Dashboard',
    USERS: 'Users',
    ARTICLES: 'Materials',
    CATEGORIES: 'Categories',
    TYPES: 'Types',
    METRICS: 'Measurement Units',
    RM: 'Reception of Merchandise',
    PURCHASE_ORDERS: 'Purchase Orders',
    INVENTORY: 'Inventory',
    HISTORY: 'Kardex',
    RECEPTION: 'Receptions',
    SUPPLIERS: 'Suppliers',
    WELCOME_USER: 'Welcome, {attribute}',
    ARE_YOU_SURE: {
      TITLE: '{attribute}',
      TEXT: 'Are you sure you want to proceed? This action cannot be undone.',
    },
    ARE_YOU_SURE_APPLIED: {
      TITLE: '{attribute}',
      TEXT: 'Applying this output will have a unit cost of {attribute}',
    },
    ARE_YOU_SURE_CANCELLED: {
      TITLE: '{attribute}',
      TEXT: 'Cancelling purchase order {attribute} will not affect any operation/activity related to this purchase order',
    },
    MODAL: {
      ADD: 'Add {attribute}',
      EDIT: 'Edit {attribute}',
      APPLIED: 'Apply {attribute}',
      SHOW: 'View {attribute}',
      RECEIVE: 'Receive transfer {attribute}',
      PROFILE: 'My Profile',
    },
    SOMETHING_WENT_WRONG: 'Oops! Something went wrong',
    CRUD_HELPER: '{attribute} successful',
    SUBTITLE_SUMMARY: 'A summary of your {attribute}',
    SEARCH: 'Search',
    ORDER_BY: 'Order by',
    NO_DATA_TO_DISPLAY: 'No data to display',
    LOCATIONS: 'Locations',
    LOCATION_DESTINATION: 'Destination Location',
    WAREHOUSE_DESTINATION: 'Destination Warehouse',
    WAREHOUSE: 'Warehouse',
    MOVEMENT_REQUEST: 'Manual Movements',
    OUT: 'Output',
    STOCK: 'Stock',
    EXISTING_QUANTITY: 'Available Quantity',
    APPROXIMATE: 'Approximate',
    TONS: 'Tons',
    TON: '{attribute} Ton',
  },
  filters: {
    TITLE: 'Filters',
  },
  actions: {
    LOGOUT: 'Logout',
    CANCEL: 'Cancel',
    CANCELLED: 'Cancelled',
    CLOSE: 'Close',
    ADD: 'Add',
    ACCEPT: 'Accept',
    SAVE: 'Save',
    EDIT: 'Edit',
    DELETE: 'Delete',
    EXPORT: 'Export',
    IMPORT: 'Import',
    CHOOSE: 'Choose',
    ACTIVATE: 'Activate',
    DETAIL: 'Detail',
    ADDED: 'Added',
    UPDATED: 'Updated',
    DOWNLOADED: 'Downloaded | Download',
    DELETED: 'Deleted',
    SEE: 'See {attribute}',
    UPLOAD: 'Upload {attribute}',
    NEW: 'New {attribute}',
    APPROVE: 'Approve',
    'IN-TRANSIT': 'In Transit',
    PRINT: 'Print',
    ADD_ARTICLE: 'Add Article',
    RECOVER: 'Recover',
    APPLIED: 'Applied',
    APPLY: 'Apply',
    ENTRY: 'Entry',
    OUT: 'Output',
    INACTIVE: 'Inactive',
    SHOW_STATUS: 'Show Status',
    SEND: 'Send',
    RECEIVED: 'Received',
    RECEIVE: 'Receive',
    IN_TRANSIT: 'In transit',
  },
  settings: {
    TITLE: 'Settings',
    THEME: 'Theme',
    THEME_MODE: { LIGHT: 'Light', DARK: 'Dark' },
    LANG: 'Language',
  },
  locale: {
    ES: 'Spanish',
    EN: 'English',
  },
  users: {
    MODEL: 'User | Users',
    PASSWORD: 'Password',
    PASSWORD_CONFIRM: 'Confirm Password',
  },
  suppliers: {
    MODEL: 'Supplier | Suppliers',
  },
  articles: {
    MODEL: 'Material | Materials',
  },
  inventories: {
    MODEL: 'Stock Inquiry | Stock Inquiries',
  },
  history: {
    MODEL: 'Kardex Inquiry | Kardex Inquiries',
    INITIAL_AMOUNT: 'Initial Cost',
    AMOUNT: 'Input Cost',
    FINAL_AMOUNT: 'Output Cost',
    DEPARTURE_AMOUNT: 'Final Cost',
  },
  categories: {
    MODEL: 'Category | Categories',
  },
  locations: {
    MODEL: 'Location | Locations',
  },
  types: {
    MODEL: 'Type | Types',
  },
  details: {
    MODEL: 'Detail | Details',
  },
  payments: {
    MODEL: 'Payment | Payments',
  },
  'measurement-units': {
    MODEL: 'Measurement Unit | Measurement Units',
  },
  warehouses: {
    MODEL: 'Warehouse | Warehouses',
  },
  'purchase-orders': {
    MODEL: 'Purchase Order | Purchase Orders',
  },
  'inventory-relocations': {
    MODEL: 'Material Relocation | Material Relocations',
  },
  'inventory-transfers': {
    MODEL: 'Material Transfer | Material Transfers',
    STATUS: 'Status Movements',
    DETAIL: 'detail',
  },
  'movement-requests': {
    MODEL: 'Manual Movement | Manual Movements',
  },
  'purchase-order-details': {
    MODEL: 'Purchase Order Detail | Purchase Order Details',
  },
  certificates: {
    MODEL: 'Certificate | Certificates',
    EXISTING: 'Existing Certificates',
  },
  receipts: {
    MODEL: 'Receipt Inquiry | Receipt Inquiries | Receipts',
    MODEL_SECONDARY: 'Merchandise Receipt | Merchandise Receipts',
    CREATING: 'We are creating the receipt, please wait a moment....',
    QUANTITY: 'Requested Quantity',
    RECEIVED: 'Quantity Already Received',
    TO_BE_RECEIVED: 'Quantity to Be Received',
    TOTAL_RECEIVED: 'Total Received',
    QUANTITY_RECEIVED: 'Quantity received',
  },
  scrap: {
    MODEL: 'Scrap | Scraps',
    USED: 'Used',
    UPDATED: 'Update Date',
  },
  columns: {
    INDICATOR: 'Indicator',
    USER: 'User',
    PRODUCT: 'Product',
    NAME: 'Name',
    PRICE: 'Price',
    STATUS: 'Status',
    CREATED_AT: 'Creation Date',
    SUPPLIER: 'Supplier',
    DATE: 'Date',
    INIT_DATE: 'Placement Date',
    ENTRY_DATE: 'Arrival Date',
    TOTAL: 'Total',
    CURRENCY: 'Currency',
    MXN: 'MXN',
    USD: 'USD',
    ACTIONS: 'Actions',
    FOLIO: 'Folio',
    LAST_NAME: 'Last Name',
    EMAIL: 'Email',
    ROL: 'Role',
    TITLE: 'Title',
    DESCRIPTION: 'Description',
    PART_NUMBER: 'Part Number',
    CATEGORY: 'Category',
    TYPE: 'Movement Type',
    METRIC: 'Measurement Unit',
    ID: 'ID',
    ARTICLE_NAME: 'Article Name',
    ARTICLE: 'Article',
    QUANTITY: '{attribute} Quantity',
    UNIT_PRICE: 'Unit Price',
    TAX: 'Tax',
    WAREHOUSE: 'Warehouse',
    REASON: 'Reason',
    PURCHASE_ORDER: 'Purchase Order',
    RM: 'RM No.',
    TYPE_MOVEMENT: 'M.T.',
    CERTIFICATE: 'Certificate | Certificate Note',
    INITIAL_QUANTITY: 'C.I',
    AMOUNT: 'C',
    FINAL_QUANTITY: 'C.F',
    FOLIO_SUPPLIER_INVOICE: 'Supplier Invoice Folio',
    NO: 'No.',
    PEDIMENT: 'Customs Declaration',
    REMAINING: 'Remaining',
    TO_BE_RECEIVED: 'To Be Received',
    RECEIVED: 'Received',
    TOTAL_RECEIVED: 'Total Received',
    RFC: 'RFC',
    CONDITIONS: 'Conditions',
    INITIAL_QUANTITY_TEXT: 'Initial Quantity',
    AMOUNT_TEXT: 'Amount',
    FINAL_QUANTITY_TEXT: 'Final Quantity',
    CERTIFICATE_FOLIO: 'Certificate Folio',
    INCHES_FRACTION: 'Inches and Fraction ',
    UNIT_COST: 'Unit Cost',
    RELOCATION: 'Relocation',
    TRANSFERS: 'Transfers',
    HAS_CREDIT: 'Has Credit?',
    CONTACT: 'Contact Name',
    CREDIT_DAYS: 'Credit Days',
    COUNTRY: 'Country',
    PHONE: 'Phone',
    GAUGE: 'Gauge',
    GALVANIZED: 'Galvanized',
    HARDNESS: 'Hardness',
    TOTAL_PAID: 'Total Paid',
    COLOR: 'Color',
    MILL: 'Mill',
    PAYMENT_PERCENTAGE: 'Payment percentage',
    USED: 'Used',
    SCRAP_USED_DATE: 'Update Date',
  },
  status: {
    ACTIVED: 'Active',
    DELETED: 'Deleted',
    INACTIVED: 'Inactive',
    REQUESTED: 'In Process',
    PENDING: 'Pending',
    APPLIED: 'Applied',
    DONE: 'Completed',
    DRAFTED: 'Draft',
    CANCELLED: 'Cancelled',
    IN_PROCESS: 'Process',
    RECEIVE: 'Receive',
    RECEIVED: 'Received',
    APPROVE: 'Approved',
    APPROVED: 'Approved',
    IN_TRANSIT: 'In Transit',
    SEND: 'Send',
    SENT: 'Sent',
    SQUARES_PRICE: 'Price Sqr',
    INVALIDATE: 'Invalidate',
  },
  validation: {
    ACCEPTED: 'The {attribute} must be accepted.',
    ACCEPTED_IF: 'The {attribute} must be accepted when {other} is {value}.',
    ACTIVE_URL: 'The {attribute} is not a valid URL.',
    AFTER: 'The {attribute} must be a date after {date}.',
    AFTER_OR_EQUAL: 'The {attribute} must be a date after or equal to {date}.',
    ALPHA: 'The {attribute} must only contain letters.',
    ALPHA_DASH:
      'The {attribute} must only contain letters, numbers, dashes, and underscores.',
    ALPHA_NUM: 'The {attribute} must only contain letters and numbers.',
    ARRAY: 'The {attribute} must be an array.',
    BEFORE: 'The {attribute} must be a date before {date}.',
    BEFORE_OR_EQUAL:
      'The {attribute} must be a date before or equal to {date}.',
    BETWEEN: {
      NUMERIC: 'The {attribute} must be between {min} and {max}.',
      FILE: 'The {attribute} must be between {min} and {max} kilobytes.',
      STRING: 'The {attribute} must be between {min} and {max} characters.',
      ARRAY: 'The {attribute} must have between {min} and {max} items.',
    },
    BOOLEAN: 'The {attribute} field must be true or false.',
    CONFIRMED: 'The {attribute} confirmation does not match.',
    CURRENT_PASSWORD: 'The password is incorrect.',
    DATE: 'The {attribute} is not a valid date.',
    DATE_EQUALS: 'The {attribute} must be a date equal to {date}.',
    DATE_FORMAT: 'The {attribute} does not match the format {format}.',
    DECLINED: 'The {attribute} must be declined.',
    DECLINED_IF: 'The {attribute} must be declined when {other} is {value}.',
    DIFFERENT: 'The {attribute} and {other} must be different.',
    DIGITS: 'The {attribute} must be {digits} digits.',
    DIGITS_BETWEEN: 'The {attribute} must be between {min} and {max} digits.',
    DIMENSIONS: 'The {attribute} has invalid image dimensions.',
    DISTINCT: 'The {attribute} field has a duplicate value.',
    EMAIL: 'The {attribute} must be a valid email address.',
    ENDS_WITH: 'The {attribute} must end with one of the following: {values}.',
    ENUM: 'The selected {attribute} is invalid.',
    EXISTS: 'The selected {attribute} is invalid.',
    FILE: 'The {attribute} must be a file.',
    FILLED: 'The {attribute} field must have a value.',
    GT: {
      NUMERIC: 'The {attribute} must be greater than {value}.',
      FILE: 'The {attribute} must be greater than {value} kilobytes.',
      STRING: 'The {attribute} must be greater than {value} characters.',
      ARRAY: 'The {attribute} must have more than {value} items.',
    },
    GTE: {
      NUMERIC: 'The {attribute} must be greater than or equal {value}.',
      FILE: 'The {attribute} must be greater than or equal {value} kilobytes.',
      STRING:
        'The {attribute} must be greater than or equal {value} characters.',
      ARRAY: 'The {attribute} must have {value} items or more.',
    },
    IMAGE: 'The {attribute} must be an image.',
    IN: 'The selected {attribute} is invalid.',
    IN_ARRAY: 'The {attribute} field does not exist in {other}.',
    INTEGER: 'The {attribute} must be an integer.',
    IP: 'The {attribute} must be a valid IP address.',
    IPV4: 'The {attribute} must be a valid IPv4 address.',
    IPV6: 'The {attribute} must be a valid IPv6 address.',
    JSON: 'The {attribute} must be a valid JSON string.',
    LT: {
      NUMERIC: 'The {attribute} must be less than {value}.',
      FILE: 'The {attribute} must be less than {value} kilobytes.',
      STRING: 'The {attribute} must be less than {value} characters.',
      ARRAY: 'The {attribute} must have less than {value} items.',
    },
    LTE: {
      NUMERIC: 'The {attribute} must be less than or equal {value}.',
      FILE: 'The {attribute} must be less than or equal {value} kilobytes.',
      STRING: 'The {attribute} must be less than or equal {value} characters.',
      ARRAY: 'The {attribute} must not have more than {value} items.',
    },
    MAC_ADDRESS: 'The {attribute} must be a valid MAC address.',
    MAX: {
      NUMERIC: 'The {attribute} must not be greater than {max}.',
      FILE: 'The {attribute} must not be greater than {max} kilobytes.',
      STRING: 'The {attribute} must not be greater than {max} characters.',
      ARRAY: 'The {attribute} must not have more than {max} items.',
    },
    MIMES: 'The {attribute} must be a file of type: {values}.',
    MIMETYPES: 'The {attribute} must be a file of type: {values}.',
    MIN: {
      NUMERIC: 'The {attribute} must be at least {min}.',
      FILE: 'The {attribute} must be at least {min} kilobytes.',
      STRING: 'The {attribute} must be at least {min} characters.',
      ARRAY: 'The {attribute} must have at least {min} items.',
    },
    MULTIPLE_OF: 'The {attribute} must be a multiple of {value}.',
    NOT_IN: 'The selected {attribute} is invalid.',
    NOT_REGEX: 'The {attribute} format is invalid.',
    NUMERIC: 'The {attribute} must be a number.',
    PASSWORD: 'The password is incorrect.',
    PRESENT: 'The {attribute} field must be present.',
    PROHIBITED: 'The {attribute} field is prohibited.',
    PROHIBITED_IF:
      'The {attribute} field is prohibited when {other} is {value}.',
    PROHIBITED_UNLESS:
      'The {attribute} field is prohibited unless {other} is in {values}.',
    PROHIBITS: 'The {attribute} field prohibits {other} from being present.',
    REGEX: 'The {attribute} format is invalid.',
    REQUIRED: 'The {attribute} field is required.',
    REQUIRED_ARRAY_KEYS:
      'The {attribute} field must contain entries for: {values}.',
    REQUIRED_IF: 'The {attribute} field is required when {other} is {value}.',
    REQUIRED_UNLESS:
      'The {attribute} field is required unless {other} is in {values}.',
    REQUIRED_WITH:
      'The {attribute} field is required when {values} is present.',
    REQUIRED_WITH_ALL:
      'The {attribute} field is required when {values} are present.',
    REQUIRED_WITHOUT:
      'The {attribute} field is required when {values} is not present.',
    REQUIRED_WITHOUT_ALL:
      'The {attribute} field is required when none of {values} are present.',
    SAME: 'The {attribute} and {other} must match.',
    SIZE: {
      NUMERIC: 'The {attribute} must be {size}.',
      FILE: 'The {attribute} must be {size} kilobytes.',
      STRING: 'The {attribute} must be {size} characters.',
      ARRAY: 'The {attribute} must contain {size} items.',
    },
    STARTS_WITH:
      'The {attribute} must start with one of the following: {values}.',
    STRING: 'The {attribute} must be a string.',
    TIMEZONE: 'The {attribute} must be a valid timezone.',
    UNIQUE: 'The {attribute} has already been taken.',
    UPLOADED: 'The {attribute} failed to upload.',
    URL: 'The {attribute} must be a valid URL.',
    UUID: 'The {attribute} must be a valid UUID.',
    PASSWORD_EQUALS: 'Passwords should be equals.',
    VALIDATION_BUNDLE: 'The value entered is invalid.',
    ATTRIBUTES: {},
  },
}
